import React from "react";
// @ts-expect-error - this will be resolved at build time
import { Box } from "@xsolla/xui-primitives";
import { useResolvedTheme, type ThemeOverrideProps } from "@xsolla/xui-core";
import type { NavBarProps, NavBarSlotProps } from "./types";

const StartSlot: React.FC<NavBarSlotProps> = ({ children, testID }) => (
  <Box
    flexDirection="row"
    alignItems="center"
    justifyContent="flex-start"
    flex={1}
    flexBasis={0}
    gap={8}
    testID={testID}
  >
    {children}
  </Box>
);

const Center: React.FC<NavBarSlotProps> = ({ children, testID }) => (
  <Box
    flexDirection="row"
    alignItems="center"
    justifyContent="center"
    flex={2}
    flexBasis={0}
    gap={8}
    testID={testID}
  >
    {children}
  </Box>
);

const EndSlot: React.FC<NavBarSlotProps> = ({ children, testID }) => (
  <Box
    flexDirection="row"
    alignItems="center"
    justifyContent="flex-end"
    flex={1}
    flexBasis={0}
    gap={8}
    testID={testID}
  >
    {children}
  </Box>
);

export const NavBarRoot: React.FC<NavBarProps & ThemeOverrideProps> = ({
  size = "md",
  bordered = false,
  backgroundColor,
  children,
  testID,
  themeMode,
  themeProductContext,
}) => {
  const { theme } = useResolvedTheme({ themeMode, themeProductContext });

  const sizeConfigs = {
    sm: { height: 48, paddingHorizontal: 12 },
    md: { height: 64, paddingHorizontal: 16 },
    lg: { height: 80, paddingHorizontal: 20 },
  };

  const currentSize = sizeConfigs[size];

  return (
    <Box
      width="100%"
      height={currentSize.height}
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      paddingHorizontal={currentSize.paddingHorizontal}
      backgroundColor={backgroundColor || theme.colors.background.primary}
      borderBottomWidth={bordered ? 1 : 0}
      borderBottomColor={theme.colors.border.secondary}
      borderStyle="solid"
      testID={testID}
    >
      {children}
    </Box>
  );
};

export const NavBar = Object.assign(NavBarRoot, {
  StartSlot,
  Center,
  EndSlot,
});

NavBarRoot.displayName = "NavBar";
StartSlot.displayName = "NavBar.StartSlot";
Center.displayName = "NavBar.Center";
EndSlot.displayName = "NavBar.EndSlot";
